ko.extenders.throttledSubscribe = function () {
    throw new Error("throttledSubscribe has been deprecated!\nUse the cleaner throttledSubscribe method instead:\n\nko.observable().throttledSubscribe(250, function(value){\n  //react to value here\n});");
};